import React, { useEffect, useState, useRef } from 'react';
import { FilterIcon, XIcon, SearchIcon } from 'lucide-react';
import { DIVISION_LEADS, TEAM_LEADS } from '../data/mockData';
interface PipelineFiltersProps {
  selectedDivision: string;
  setSelectedDivision: (val: string) => void;
  selectedTeam: string;
  setSelectedTeam: (val: string) => void;
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  onClearFilters: () => void;
}
export const PipelineFilters: React.FC<PipelineFiltersProps> = ({
  selectedDivision,
  setSelectedDivision,
  selectedTeam,
  setSelectedTeam,
  searchQuery,
  setSearchQuery,
  onClearFilters
}) => {
  const availableTeams = selectedDivision ? TEAM_LEADS[selectedDivision] || [] : Object.values(TEAM_LEADS).flat();
  const hasActiveFilters = selectedDivision !== '' || selectedTeam !== '' || searchQuery !== '';
  return <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4 transition-colors duration-200" data-id="element-71">
      <div className="flex flex-wrap items-center gap-4" data-id="element-72">
        {/* Search Input */}
        <div className="relative" data-id="element-73">
          <SearchIcon className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-74" />
          <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search borrower, loan #, officer..." className="text-sm border border-gray-300 dark:border-gray-600 rounded-md pl-9 pr-3 py-2 bg-white dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent w-64 placeholder-gray-400 dark:placeholder-gray-500 transition-colors duration-200" data-id="element-75" />
        </div>

        <div className="h-6 w-px bg-gray-200 dark:bg-gray-600 hidden sm:block transition-colors duration-200" data-id="element-76"></div>

        <div className="flex items-center text-gray-500 dark:text-gray-400 mr-2 transition-colors duration-200" data-id="element-77">
          <FilterIcon className="w-4 h-4 mr-2" data-id="element-78" />
          <span className="text-sm font-medium uppercase tracking-wider" data-id="element-79">
            Filters
          </span>
        </div>

        {/* Division Lead Filter */}
        <select value={selectedDivision} onChange={e => {
        setSelectedDivision(e.target.value);
        setSelectedTeam('');
      }} className="text-sm border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#6DB33F] focus:border-transparent min-w-[160px] transition-colors duration-200" data-id="element-80">
          <option value="" data-id="element-81">All Division Leads</option>
          {DIVISION_LEADS.map(lead => <option key={lead} value={lead} data-id="element-82">
              {lead}
            </option>)}
        </select>

        {/* Team Lead Filter */}
        <select value={selectedTeam} onChange={e => setSelectedTeam(e.target.value)} className="text-sm border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-[#6DB33F] focus:border-transparent min-w-[160px] transition-colors duration-200" data-id="element-83">
          <option value="" data-id="element-84">All Team Leads</option>
          {availableTeams.map(lead => <option key={lead} value={lead} data-id="element-85">
              {lead}
            </option>)}
        </select>

        {/* Clear Filters */}
        {hasActiveFilters && <button onClick={onClearFilters} className="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 flex items-center gap-1 px-2 py-2 transition-colors" data-id="element-86">
            <XIcon className="w-4 h-4" data-id="element-87" />
            Clear
          </button>}
      </div>
    </div>;
};